module.exports = __webpack_public_path__ + "static/media/icon-store.4d183a74.svg";